import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getLivescoreQuery } from '../queries/matches';

import { MatchStatus } from '@shared-types/match.types';
import { IS_TEST } from '@utilities/browser';

export const useLivescore = (competitionIds: string[], pollingTime = 60000) => {
  const { data: matches } = useQuery({
    ...getLivescoreQuery(competitionIds),
    refetchInterval: !IS_TEST && pollingTime,
  });

  const liveMatches = useMemo(() => matches?.filter((m) => m.status === MatchStatus.LIVE) ?? [], [matches]);

  return liveMatches;
};
